import React from 'react'
import PropTypes from 'prop-types'

import noop from 'lodash/noop'

import { Modal } from 'Components/UI'

import { useBaseTheme } from 'Hooks'
import { _ } from 'Services/I18n'

import { ModalContent, ModalText, ModalButton } from './styles'

const ExternalLinkModal = ({ url, onClose }) => {
  const { primaryColor, primaryTextColor, roundedBorder, websitePopupMessage } =
    useBaseTheme()

  const handleConfirm = () => {
    const newWindow = window.open()
    newWindow.opener = null
    newWindow.location = url

    onClose()
  }

  return (
    <Modal isOpen onCallback={onClose}>
      <ModalContent>
        <ModalText>{websitePopupMessage}</ModalText>
        <ModalButton
          background={primaryColor}
          color={primaryTextColor}
          roundedborder={roundedBorder}
          onClick={handleConfirm}
        >
          {_('action.ok')}
        </ModalButton>
      </ModalContent>
    </Modal>
  )
}

ExternalLinkModal.defaultProps = {
  onClose: noop,
}

ExternalLinkModal.propTypes = {
  url: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

export default ExternalLinkModal
